import { render, staticRenderFns } from "./formData.vue?vue&type=template&id=40d2b25f&scoped=true"
import script from "./formData.vue?vue&type=script&lang=js"
export * from "./formData.vue?vue&type=script&lang=js"
import style0 from "./formData.vue?vue&type=style&index=0&id=40d2b25f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2b25f",
  null
  
)

export default component.exports